import { Radio as MuiRadio, withStyles } from '@material-ui/core';
import { Liquidity } from '../../design';
import { withDefaults } from '../utils';
export const Radio = withStyles({
    root: {
        color: Liquidity.colors.misc.form,
    },
    disabled: {
        color: Liquidity.colors.misc.formDisabled,
    },
    checked: {
        color: Liquidity.colors.feedback.success,
        '&$disabled': {
            color: Liquidity.colors.misc.formDisabled,
        },
    },
    colorPrimary: {
        '&$disabled': {
            color: Liquidity.colors.misc.formDisabled,
        },
        '&$checked': {
            color: Liquidity.colors.primary.brightGreen,
            '&$disabled': {
                color: Liquidity.colors.misc.formDisabled,
            },
        },
    },
    colorSecondary: {
        '&$disabled': {
            color: Liquidity.colors.misc.formDisabled,
        },
        '&$checked': {
            color: Liquidity.colors.supporting.deepBlue,
            '&$disabled': {
                color: Liquidity.colors.misc.formDisabled,
            },
        },
    },
})(withDefaults(MuiRadio, { color: 'default' }));
export { RadioGroup, useRadioGroup } from '@material-ui/core';
//# sourceMappingURL=Radio.js.map